import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useEffect } from 'react';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';

function App() {
  useEffect(() => {
    // Check if user is logged in on mount
    localStorage.getItem('accessToken');
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-black flex flex-col">
        {/* Main Content */}
        <main className="flex-1 w-full">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

// NotFound Component
function NotFound() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="relative bg-white border-4 border-black p-12 text-center">
        <div className="absolute -top-1 -right-1 w-full h-full bg-red-500 -z-10"></div>
        <h1 className="text-9xl font-black text-black mb-4">404</h1>
        <div className="h-1 bg-black mb-6"></div>
        <p className="text-black font-mono uppercase tracking-wider mb-8">Page Not Found</p>
        <Link to="/" className="relative inline-block px-8 py-4 bg-black text-white font-black border-4 border-black transition-transform hover:translate-x-1 hover:-translate-y-1">
          <div className="absolute -top-1 -right-1 w-full h-full bg-gray-700 -z-10"></div>
          GO BACK HOME
        </Link>
      </div>
    </div>
  );
}

export default App;
